/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

let CartDrawer = document.querySelector('#sidebar-cart');
document.addEventListener('product:added', function(event) {
  CartDrawer.classList.add('show-message');
});

function showScrollToTop(el) {
  let windowHeight = window.innerHeight;
  let scrollProgress = document.documentElement.scrollTop;
  if (scrollProgress > windowHeight) {
    el.classList.add('is-visible');
  } else {
    el.classList.remove('is-visible');
  }
}

const rootElement = document.documentElement;
const scrollToTop = document.getElementById('scrollToTop');

if (scrollToTop) {
  scrollToTop.addEventListener('click', function() {
    rootElement.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  });

  showScrollToTop(scrollToTop);
  document.addEventListener('scroll', function() {
    showScrollToTop(scrollToTop);
  });
}

console.log(document.body);
const body = document.body;

function bind2Qty(inp1, inp2) {
  inp1.addEventListener('change', function(e) {
    inp2.value = e.target.value;
  });
  inp2.addEventListener('change', function(e) {
    inp1.value = e.target.value;
  });
}

if (body.classList.contains('template-product')) {
  const target = document.querySelector('[data-action="add-to-cart"]');
  function handleIntersection(entries) {
    entries.map((entry) => {
      if (entry.isIntersecting) {
        // element is in viewport
        body.classList.remove('is-sticky-atc');
      } else {
        // element is out of viewport
        body.classList.add('is-sticky-atc');
      }
    });
  }
  const observer = new IntersectionObserver(handleIntersection);
  observer.observe(target);

  let qtyInput = document.querySelector('[name="quantity"]');
  let qtyInputGhost = document.querySelector('[name="quantity-ghost"]');
  bind2Qty(qtyInput, qtyInputGhost);
}